export default __webpack_public_path__ + "static/hack4change-final@3x-1b745c06fc4d1aa973cb5ef5b8767bae.png";